import { cloneDeep, isEmpty } from "lodash";
import { memo, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../../../app/common-components/Button";
import { configurationApi } from "../../../../../app/services/configurationApi";
import { effciencyApi } from "../../../../../app/services/efficiencyApi";
import { useCommonAlert } from "../../../../../app/utilities/helpers";
import "../styles.scss";
import AccessTable from "./AccessTable";


const BambooRoles = () => {
  const [RoleState, setState] = useState({
    tableHeader: [],
    tableBody: [],
  });
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const bambooList = ["Admin", "Clone", "Build", "Edit", "View"];

  const { state } = useLocation();

  const row = state?.row;

  const navigate = useNavigate();
  const [getGroups] = effciencyApi.useLazyGetGroupsQuery();
  const [getAccessDetailsById] =
    configurationApi.useLazyGetAccessDetailsByIdQuery();
  const [saveConfig] = configurationApi.useSaveConfigMutation();

  const handleOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.checked;
    const access = e.target.value;
    const clonedState = cloneDeep(RoleState);

    if (access === "Admin") {
      const selectedArr = clonedState.tableBody.defaultCat.map((data) => {
        if (data.value === "Admin") {
          return {
            ...data,
            [name]: value,
          };
        }
        return {
          ...data,
          [name]: value,
          [`${name}_disable`]: value,
        };
      });

      setState((state) => ({
        ...state,
        tableBody: {
          defaultCat:selectedArr },
      }));
    } else if (access !== "View") {
      const selectedArr = clonedState.tableBody.defaultCat.map((data) => {
        if (data.value === access) {
          return {
            ...data,
            [name]: value,
          };
        } else if (data.value === "View") {
          return {
            ...data,
            [name]: value,
            [`${name}_disable`]: value,
          };
        }
        return data;
      });
      setState((state) => ({
        ...state,
        tableBody: { defaultCat:selectedArr },
      }));
    } else {
      const selectedArr = clonedState.tableBody.defaultCat.map((data) => {
        if (data.value === access) {
          return {
            ...data,
            [name]: value,
          };
        }
        return data;
      });
      setState((state) => ({
        ...state,
        tableBody: {
          defaultCat:selectedArr
        },
      }));
    }
  };
  const mapObject = (data, parentObject) => {
    let adminAccess = false;
    let adminArray = [];
    
     const formatedArray = bambooList.map((tool) => {
      const grpObject ={};
        data.forEach((grp) => {
          let fieldPresent = false;
          if(!isEmpty(parentObject)){
            Object.keys(parentObject).forEach((key) => {
              if(key === grp.groups && tool === "Admin"){
                parentObject[key].forEach((access) => {
                  if(access.toLowerCase() === 'admin'){
                    adminAccess = true;
                    adminArray.push(key);
                    grpObject[key] = true;
                    fieldPresent = true;
                  }
                });
              }
              else if(key === grp.groups && parentObject[key].length === 1 && tool === 'View'){
                grpObject[key] = true;
                fieldPresent = true;
              }
              else if(key === grp.groups){
                if(tool === "View"){
                  grpObject[`${grp.groups}_disable`] = true;
                }
                grpObject[key] = true;
                fieldPresent = true;
              }
            });
          }
          if(adminAccess && tool !== 'Admin'){
            const index = adminArray.findIndex((data) => data === grp.groups);
            if(index !== -1){
              grpObject[grp.groups] = true;
              grpObject[`${grp.groups}_disable`] = true;
              fieldPresent = true;
            }
          } 
          if(!fieldPresent){
            grpObject[grp.groups] = false;
          } 
        });
        return {
          ...grpObject,
          value:tool,
        };
     });
     return formatedArray;
  };
  const getGroup = async () => {
    const { data } = await getGroups();
    const accessData = await getAccessDetailsById(row.id);
    const tableHeader = [
      [
        {
          key: 1,
          text: "Permissions",
          rowSpan: "2",
          width: "25%"
        },
        {
          key: 2,
          text: "Role",
          colSpan: data.length,
          className: "text-center",
        },
      ],
    ];
    const subHeaders = data.map((grp, idx) => ({
      key: idx,
      text: grp.groups,
      className: "text-center toolbit_confic",
    }));
    tableHeader.push(subHeaders);
    const parentObject = accessData?.isSuccess
      ? JSON.parse(accessData?.data.permission)
      : {};
  
    const tableBody =  mapObject(data, parentObject);
    setState((state) => ({
      ...state,
      tableHeader,
      tableBody: {
        defaultCat: tableBody
      },
    }));
  };

  const getPermission = () => {
    const devopsToolGroups = {};
    Object.keys(RoleState.tableBody).forEach((key) => {
      RoleState.tableBody[key].forEach((item) =>
        Object.keys(item).forEach((key) => {
          if (item[key] === true && !key.includes("_disable")) {
            devopsToolGroups[key] = devopsToolGroups[key]
              ? devopsToolGroups[key]
              : [];
            devopsToolGroups[key].push(item.value.toUpperCase());
          }
        })
      );
    });
    return devopsToolGroups;
  };
  const cancelConfig = () => {
    navigate("/configuration/administration/tools");
  };
  const saveConfiguration = () => {
    localStorage.removeItem("toolsCurrentPage");
    localStorage.removeItem("isConfigClicked");
    const permissionData = getPermission();

    const { id, toolName, type, userName, password, url, apiToken, sslValue } =
      row;
    const payload = {
      devopsToolGroups: JSON.stringify(permissionData, null, 4),
      toolId: row.id,
      tools: {
        id,
        toolName,
        type,
        userName,
        password,
        url,
        apiToken,
        sslValue,
      },
    };
    saveConfig({ payload,userName }).then((data) => {
      if (data.error.originalStatus === 201) {
        callCommonAlert("success",data.error.data);
        hideCommonAlert();
        setTimeout(() => navigate("/configuration/administration/tools"), 2000);
      } else {
        callCommonAlert("error","Bamboo role configuration failed to save");
        hideCommonAlert();
      }
    });
  };

  useEffect(() => {
    if(state === null){
      navigate("/configuration/administration/tools");
      return;
    }
    getGroup();
  }, []);

  return (
    <>
      <div className="grid-table">
        <AccessTable
          tableHeaders={RoleState.tableHeader}
          body={RoleState.tableBody}
          onChange={(e) => handleOnChange(e)}
        />
      </div>
      <div className="btnwrap config_btn">
        <Button
          text="Cancel"
          className={"default-cancelBtnStyle btn btn-primary-btn"}
          onClick={(e) => {
            e.preventDefault();
            cancelConfig();
          }}
        />
        <Button
          text="Save"
          className={"default-btnStyle btn btn-primary-btn"}
          onClick={(e) => {
            e.preventDefault();
            saveConfiguration();
          }}
        />
      </div>
    </>
  );
};

export default memo(BambooRoles);
